module.exports = __webpack_public_path__ + "static/img/BU01.16e91b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01.jpg
// module id = N6Il
// module chunks = 1